import React from 'react';
import SectionHeader from '@/components/SectionHeader';
import { useSEO } from '@/lib/useSEO';
import { Shield, Compass, Handshake, CurrencyEur } from '@phosphor-icons/react';

export default function About() {
  useSEO({
    title: 'Over ons & disclaimer',
    description: 'Noodpakket.nl is een onafhankelijk Nederlands platform. Lees onze missie, werkwijze en het affiliate-disclaimer.',
    path: '/over-ons',
  });
  return (
    <div data-testid="page-about">
      <section className="border-b border-border bg-card">
        <div className="container py-16 lg:py-24">
          <SectionHeader
            eyebrow="Over jouw noodpakket.nl"
            title="Onafhankelijk, praktisch en Nederlands."
            description="Wij geloven dat voorbereid zijn geen prepper-hobby hoort te zijn, maar een normale Nederlandse gewoonte — net zoals zwemles en fietsverlichting."
            accent
          />
        </div>
      </section>

      <section className="container py-16 lg:py-20">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <p className="text-lg text-foreground leading-relaxed">
              Jouw Noodpakket.nl is ontstaan nadat de <strong>Rijksoverheid</strong> in 2022 iedereen adviseerde minimaal
              72 uur zelfredzaam te zijn. Voor veel mensen bleef onduidelijk: <em>wat heb je dan eigenlijk nodig?</em>
            </p>
            <p className="mt-5 text-lg text-foreground leading-relaxed">
              Wij brengen de beste producten bij elkaar op één plek, vergelijken shops, en helpen je met onze
              wizard een pakket samen te stellen dat past bij jouw huishouden, woonplaats en zorgen.
            </p>
          </div>
          <div className="bg-muted/50 border border-border p-8 rounded-sm">
            <h3 className="font-display font-black text-2xl mb-5">Onze principes</h3>
            <ul className="space-y-5">
              <li className="flex gap-4">
                <Compass weight="duotone" size={28} className="text-primary flex-shrink-0" />
                <div>
                  <div className="font-bold">Praktisch, nooit paniekerig</div>
                  <div className="text-sm text-muted-foreground">Rustige, feitelijke informatie — zonder doom-porn.</div>
                </div>
              </li>
              <li className="flex gap-4">
                <Shield weight="duotone" size={28} className="text-primary flex-shrink-0" />
                <div>
                  <div className="font-bold">Onafhankelijk advies</div>
                  <div className="text-sm text-muted-foreground">Wij accepteren geen betaalde plaatsingen in onze 'Beste keuzes'.</div>
                </div>
              </li>
              <li className="flex gap-4">
                <Handshake weight="duotone" size={28} className="text-primary flex-shrink-0" />
                <div>
                  <div className="font-bold">Eerlijk verdienmodel</div>
                  <div className="text-sm text-muted-foreground">Wij verdienen een kleine commissie op sommige links — dit maakt onze content gratis.</div>
                </div>
              </li>
              <li className="flex gap-4">
                <CurrencyEur weight="duotone" size={28} className="text-primary flex-shrink-0" />
                <div>
                  <div className="font-bold">Geen verborgen kosten</div>
                  <div className="text-sm text-muted-foreground">Prijzen die je ziet zijn de prijzen die je betaalt bij de shop.</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div id="disclaimer" className="mt-20 border-t border-border pt-10">
          <h2 className="font-display font-black text-2xl mb-4">Disclaimer</h2>
          <div className="text-sm text-muted-foreground leading-relaxed max-w-3xl space-y-3">
            <p>
              Alle informatie op jouw noodpakket.nl is met zorg samengesteld maar kan geen vervanging zijn voor professioneel advies.
              Bij levensbedreigende situaties bel altijd <strong>112</strong>.
            </p>
            <p>
              De links naar externe webshops zijn affiliate-links. Wanneer je via zo'n link een product koopt, ontvangen wij mogelijk een kleine commissie van de verkopende partij.
              De prijs voor jou verandert hierdoor niet.
            </p>
            <p>
              Beoordelingen, scores en "beste keuze"-badges zijn gebaseerd op redactionele review en gebruikerservaringen op het moment van schrijven. Specificaties en prijzen kunnen tussentijds wijzigen.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
